







import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'empty'
})
export default class empty extends Vue {
  @Prop({ default: '暂无相关数据哦！' }) public emptyText: string
  @Prop({ default: '100%' }) public width: string
  @Prop({ default: '100%' }) public height: string
}
